import React from "react";

import styles from "./Toast.scss";

export interface ToastOverlayProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Optional CSS value for the top position of the toast overlay.
   *
   * Use this to position toasts below fixed headers or other UI elements that might
   * obscure them. Accepts any valid CSS top value (e.g., "80px", "5rem", "10%").
   *
   * @default undefined (uses the default top position from Toast.scss)
   */
  top?: string;
}

export function ToastOverlay({ top, style, ...props }: ToastOverlayProps) {
  const overlayStyle = top ? { ...style, top } : style;

  return (
    <div
      {...props}
      id="toast-overlay"
      data-testid="toast-overlay"
      className={styles.toastOverlay}
      style={overlayStyle}
    />
  );
}
